// @flow
import type {Node} from 'react'
import React, {useMemo} from 'react'
import {useFragment, graphql} from 'react-relay'
import ProposalContext from './ProposalContext'

const proposalFragment = graphql`
  fragment ProposalContextProviderFragment_proposal on Proposal {
    id
    databaseId
    tension {
      id
      databaseId
      body      
    }
    circle {
      id
      databaseId
      localizedName
    }
  }
`

type Props = {
  children: Node,
  proposal: any,
}

export default function ProposalContextProviderFragment({children, proposal}: Props): Node {
  const propData = useFragment(proposalFragment, proposal)
  const value = useMemo(() => (
    propData == null ? null : {
      id: propData.id,
      databaseId: propData.databaseId,
      tension: {
        id: propData.tension.id,
        databaseId: propData.tension.databaseId,
        body: propData.tension.body,
      },
      circle: {
        databaseId: propData.circle.databaseId,
        localizedName: propData.circle.localizedName,
      },
    }), [propData])
  return (
    <ProposalContext.Provider value={value}>
      {children}
    </ProposalContext.Provider>
  )
}
